import { render } from "./PortfolioToB.vue?vue&type=template&id=1b9ece25"
import script from "./PortfolioToB.vue?vue&type=script&lang=js"
export * from "./PortfolioToB.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__